/**
 * Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import { Map as OlMap } from 'ol';
import { Coordinate } from 'ol/coordinate';
import { Pixel } from 'ol/pixel';
import Projection from 'ol/proj/Projection';

import { getDistance } from 'ol/sphere';
import { Injectable } from '@angular/core';
import { LoggerService } from './logger.service';

@Injectable()
export class MeasureService {
    private readonly unit: string;
    private moveEvent: any;
    private clickEvent: any;
    private _previousCoordinate: Coordinate;
    private map: OlMap;
    private projection: Projection;
    private lastPixel: Pixel;
    private total = 0;
    private mouseElement: HTMLElement;

    constructor(private logger: LoggerService) {
        this.unit = 'ft';
        this.moveEvent = null;
        this.clickEvent = null;

        this._previousCoordinate = null;
    }

    /**
     * @param map {ol.Map}
     */
    setMap(map) {
        this.map = map;
        this.projection = map.getView().getProjection();
    }

    public static lengthFeetToMeters(distance) {
        return distance * 0.3048;
    }

    public static lengthMetersToFeet(distance) {
        return distance * 3.28084;
    }

    public static areaMetersToFeet(area) {
        return area * 10.76;
    }

    /**
     *
     * @param p1 {ol.Coordinate}
     * @param p2 {ol.Coordinate}
     */
    public static distanceLatLon(p1: Coordinate, p2: Coordinate) {
        return getDistance(p1, p2);
    }

    private static getMidpoint(c1, c2) {
        return [
            Math.abs(c1[0] - c2[0]) / 2 + Math.min(c1[0], c2[0]),
            Math.abs(c1[1] - c2[1]) / 2 + Math.min(c1[1], c2[1]),
        ];
    }
}
